import Form from 'app/components/Form';

const ContentProviderForm = props => {
  const {
    contentProvider,
    onClose,
    onSubmit,
    action
  } = props;

  let header = null;
  let disabled = false;

  // TODO: Historically Content Provider updates were intended to allow the parent account to make
  // account level updates, such as name, website, etc, to their providers using their own creds
  // Since this way of operating isn't actively being supported there isn't really a reason to build it out
  // here.
  if (action === 'update') {
    header = 'Edit Fields';
    disabled = true;
  }

  let fields = [
    { name: 'access_token', label: 'Access Token', type: 'text', value: contentProvider?.access_token, helperText: 'Enter an existing account\'s access token', disabled: disabled },
    { name: 'client_provider_id', label: 'Client Provider ID', type: 'text', value: contentProvider?.client_provider_id, helperText: 'Enter a custom internal ID for this company', disabled: disabled }
  ]

  return (
    <Form {...{
      header,
      fields,
      action,
      onClose,
      onSubmit
    }} />
  );
}

export default ContentProviderForm;
